import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=3ec04618&"
import script from "./Stars.vue?vue&type=script&lang=js&"
export * from "./Stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports